<template>
  <section class="home-hero">
    <div class="hero-content">
      <div class="hero-text">
        <h1 class="main-title">慧标领航</h1>
        <h2 class="sub-title">全流程电子招投标服务平台</h2>
        <p class="description">
          专业服务、无缝对接
        </p>
      </div>
    </div>
    <ul class="btn-cards">
      <li @click="handleClick('supplier')">
        <div>
          <p>供应商登录/注册</p>
          <p>欢迎使用慧标领航招投标平台</p>
        </div>
        <img src="@/assets/homeImages/home-icon01.png" alt="">
      </li>
      <li @click="handleClick('expert')">
        <div>
          <p>评审专家登录/注册</p>
          <p>欢迎使用慧标领航招投标平台</p>
        </div>
        <img src="@/assets/homeImages/home-icon02.png" alt="">
      </li>
      <li @click="handleClick('admin')">
        <div>
          <p>采购人登录</p>
          <p>欢迎使用慧标领航招投标平台</p>
        </div>
        <img src="@/assets/homeImages/home-icon03.png" alt="">
      </li>
       <li @click="handleClick('tenderer')">
        <div>
          <p>代理机构登录</p>
          <p>欢迎使用慧标领航招投标平台</p>
        </div>
        <img src="@/assets/homeImages/home-icon03.png" alt="">
      </li>
    </ul>

  </section>
</template>

<script>
export default {
  name: 'HomeHero',
  methods: {
    handleClick(type) {
      console.log('点击了按钮');
      this.$router.push({ path: '/login', query: { type } });
    },
  }
};
</script>

<style lang="less" scoped>
p {
  margin-bottom: 0;
}
@font-face {
  font-family: "YouSheBiaoTiHei";
  src: url("@/assets/YouSheBiaoTiHei-2.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
.home-hero {
  width: 100%;
  height: 572px;
  background: url('@/assets/homeImages/home-bg01.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  margin-bottom: 100px;

  .hero-content {
    width: 1200px;
    margin: auto;

    .hero-text {
      padding-top: 180px;

      .main-title {
        font-size: 60px;
        color: #2A375E;
        margin-bottom: 12px;
        font-family: "YouSheBiaoTiHei", sans-serif;
      }

      .sub-title {
        font-size: 60px;
        color: #2A375E;
         font-family: "YouSheBiaoTiHei", sans-serif;
      }

      .description {
        color: #000000;
        font-size: 18px;
      }
    }

    .cards-container {
      display: flex;
      flex-direction: column;
      gap: 24px;
      margin-top: 32px;

      @media (min-width: 768px) {
        flex-direction: row;
      }

      .hero-card {
        background-color: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(24px); // backdrop-blur-xl
        border-radius: 16px; // rounded-2xl
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
          0 10px 10px -5px rgba(0, 0, 0, 0.04); // shadow-xl
        padding: 32px;
        flex: 1;
        border: 1px solid #eff6ff; // border-blue-50
        cursor: pointer;
        position: relative;
        overflow: hidden;
        transition: all 0.3s;
        transform: translateY(0);

        &:hover {
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); // shadow-2xl
          transform: translateY(-4px);

          .card-decoration {
            transform: scale(1.1);
          }

          .action-btn {
            background-color: #2563eb; // bg-blue-600
            color: white;
          }
        }

        .card-decoration {
          position: absolute;
          top: 0;
          right: 0;
          width: 96px;
          height: 96px;
          background-color: #eff6ff; // bg-blue-50
          border-bottom-left-radius: 9999px; // rounded-bl-full
          margin-right: -40px;
          margin-top: -40px;
          transition: transform 0.5s;
        }

        .card-title {
          font-size: 24px;
          font-weight: 700;
          color: #1f2937; // gray-800
          margin-bottom: 8px;
          position: relative;
          z-index: 10;
        }

        .card-desc {
          color: #6b7280; // gray-500
          font-size: 14px;
          position: relative;
          z-index: 10;
        }

        .card-action {
          margin-top: 24px;
          display: flex;
          justify-content: flex-end;
          position: relative;
          z-index: 10;

          .action-btn {
            width: 48px;
            height: 48px;
            background-color: #dbeafe; // bg-blue-100
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #2563eb; // text-blue-600
            transition: all 0.3s;
            font-size: 20px;
          }
        }
      }
    }
  }

  .btn-cards {
    position: absolute;
    bottom: -64px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;

    >li {
      width: 338px;
      height: 107px;
      box-shadow: 0px 4px 24px 0px #B1C1E529;
      background: #fff;
      margin-right: 16px;
      border-radius: 8px;
      padding: 0 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      >div {
        >p:nth-child(1) {
          color: #354167;
          font-size: 20px;
          margin-bottom: 8px;
        }

        >p:nth-child(2) {
          font-size: 14px;
          color: #8A92A9;
        }
      }

      >img {
        width: 92px;
        height: 92px;
        margin-top: -45px;
      }
    }

    >li:last-child {
      margin-right: 0;
    }
  }
}

// @keyframes blob {
//   0% {
//     transform: translate(0px, 0px) scale(1);
//   }

//   33% {
//     transform: translate(30px, -50px) scale(1.1);
//   }

//   66% {
//     transform: translate(-20px, 20px) scale(0.9);
//   }

//   100% {
//     transform: translate(0px, 0px) scale(1);
//   }
// }</style>
